import { Component, Input, OnInit } from '@angular/core';
import { CommonDetailComponent } from '../common-detail/common-detail.component';
import Vehicle from '../../../../../core/data/models/vehicle.model';
import { PolicyDto } from '../common-detail/policyDto';
import { DecimalPipe } from '@angular/common';
import Home from '../../../../../core/data/models/home.model';
import HousePolicy from '../../../../../core/data/models/house.policy.model';

@Component({
  selector: 'app-house-detail',
  imports: [CommonDetailComponent],
  providers: [DecimalPipe],
  templateUrl: './house-detail.component.html',
  styleUrl: './house-detail.component.css',
})
export class HouseDetailComponent {
  dto: PolicyDto = {} as any;
  houseInfoLabes: {
    label: string;
    attribute: keyof Home;
    type?: 'currency' | 'text';
  }[] = [
    {
      label: 'Ciudad',
      attribute: 'city',
    },
    {
      label: 'Sector',
      attribute: 'sector',
    },
    {
      label: 'Barrio',
      attribute: 'neighborhood',
    },
    {
      label: 'Calle',
      attribute: 'street',
    },
    {
      label: 'Tipo',
      attribute: 'type',
    },
    {
      label: 'Nombre edificio',
      attribute: 'buildingName',
    },
    {
      label: 'Año construcción',
      attribute: 'constructionYears',
    },
    {
      label: 'Valor de la propiedad',
      attribute: 'propertyValue',
      type: 'currency',
    },
    {
      label: 'Valor contenido',
      attribute: 'propertyContent',
      type: 'currency',
    },
  ];
  policyNumber: string = '';

  constructor(private decimalPipe: DecimalPipe) {}

  @Input() set policy(policyNumber: string | null) {
    this.policyNumber = policyNumber ? policyNumber : '';
  }

  @Input() set value(policies: HousePolicy[]) {
    if (policies && policies.length) {
      this.dto = {
        label: `${policies.length} propiedades`,
        searchLabel: 'Buscar propiedad',
        emptyLabel: 'No tiene propiadades asociadas a esta póliza',
        policies: policies.map((policy) => {
          return {
            infoLabels: this.houseInfoLabes.map((infoLabel) => {
              let value = policy.home[infoLabel.attribute];

              switch (infoLabel.type) {
                case 'currency':
                  value = `$${this.decimalPipe.transform(value, '1.0-0')}`;
                  break;
              }

              return {
                label: infoLabel.label,
                value: value || 'N/A',
              };
            }),
            cardContent: `
               <div class="d-flex align-items-center gap-1 my-1">
                  <span><strong>${policy.home.buildingName || 'Propiedad'}</strong></span>
              </div>
              <div class="d-flex align-items-center gap-1 my-1">
                  <span>${policy.home.sector}</span>
                  <span> ${policy.home.city}</span>
              </div>
              <div class="d-flex align-items-center gap-1 my-1">
                  <span>Valor de la propiedad: </span>
                  <strong class="text-primary text-colonial">$${this.decimalPipe.transform(policy.home.propertyValue, '1.0-0')}</strong>
              </div>

            `,
            coverages: policy.coverage,
          };
        }),
        detailLabel: 'Información de la propiedad',
        policyNumber: this.policyNumber,
      };
    }
  }
}
